/* ==========================================================================
   Big Gun Exhaust — Digital Garage feature (preview build)
   Vanilla ES2017+. No jQuery dependency. Self-contained.
   ========================================================================== */

(function () {
  'use strict';

  // ------------------------------------------------------------------------
  // Constants
  // ------------------------------------------------------------------------
  var STORAGE_KEY = 'bge_garage_v1';
  var MAX_VEHICLES = 5;
  var VOCAB_URL = (window.BGE_GARAGE_CONFIG && window.BGE_GARAGE_CONFIG.vocabUrl) || '';

  // Known canonical makes (used for tag parsing fallback when vocab makes
  // are not yet loaded). Match the migration script.
  var KNOWN_MAKES = [
    'Polaris', 'Honda', 'Yamaha', 'Can-Am', 'Can Am',
    'Arctic Cat', 'Kawasaki', 'Suzuki', 'KTM',
    'Harley-Davidson', 'Harley', 'John Deere', 'Hisun',
    'Massimo', 'Husqvarna', 'Sherco', 'GasGas', 'Textron',
    'Apollo', 'Kymco'
  ];
  var MAKE_CANONICAL = {
    'Can Am': 'Can-Am',
    'Harley': 'Harley-Davidson'
  };

  var YEAR_RANGE_RE = /^\d{2}-\d{2}$|^\d{4}-\d{4}$/;
  var YEAR_SINGLE_RE = /^\d{4}$|^\d{2}$/;

  // ------------------------------------------------------------------------
  // Storage helpers
  // ------------------------------------------------------------------------
  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { vehicles: [], activeId: null };
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.vehicles)) return { vehicles: [], activeId: null };
      return data;
    } catch (e) {
      return { vehicles: [], activeId: null };
    }
  }

  function saveState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) { /* swallow quota errors */ }
  }

  // ------------------------------------------------------------------------
  // Tag parser — mirrors the Python migration script logic.
  // Given a list of tag strings, returns { makes, models, yearStart, yearEnd, series }.
  // ------------------------------------------------------------------------
  var KNOWN_SERIES = ['EVO R', 'EVO U', 'EVO M', 'EVO S', 'EXO', 'EXO R', 'EXO Stainless',
                      'ECO', 'Ballistic', 'Explorer', 'WARHEAD', 'Banshee', 'Stealth'];
  var PARENT_CAT_TAGS = ['Exhausts + Pipes', 'Slip On Mufflers', 'Slip On Muffler Mufflers',
                         'Full Exhaust Systems', 'TFI Power Boxes', 'Head Pipes', 'Rev Boxes',
                         'Replacement Parts', 'Accessories', 'Gear', 'Exhaust'];
  var LEGACY_NOISE = ['woo_import_1', 'featured'];

  function parseYearToken(s) {
    s = String(s).trim();
    var m = s.match(/^(\d{2})-(\d{2})$/);
    if (m) {
      var y1 = parseInt(m[1], 10);
      var y2 = parseInt(m[2], 10);
      var full1 = y1 < 80 ? 2000 + y1 : 1900 + y1;
      var full2 = y2 < 80 ? 2000 + y2 : 1900 + y2;
      if (full2 < full1) full1 = 1900 + y1;
      return [full1, full2];
    }
    m = s.match(/^(\d{4})-(\d{4})$/);
    if (m) return [parseInt(m[1], 10), parseInt(m[2], 10)];
    m = s.match(/^(\d{4})$/);
    if (m) { var y = parseInt(m[1], 10); return [y, y]; }
    m = s.match(/^(\d{2})$/);
    if (m) { var y2d = parseInt(m[1], 10); var full = y2d < 80 ? 2000 + y2d : 1900 + y2d; return [full, full]; }
    return null;
  }

  function parseTags(tagsStr) {
    var result = { makes: [], models: [], yearStart: null, yearEnd: null, series: [] };
    if (!tagsStr) return result;
    var tags = tagsStr.split('|').map(function (t) { return t.trim(); }).filter(Boolean);
    var yearRanges = [];
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i];
      var tLower = t.toLowerCase();
      if (LEGACY_NOISE.indexOf(t) >= 0 || LEGACY_NOISE.indexOf(tLower) >= 0) continue;
      if (PARENT_CAT_TAGS.indexOf(t) >= 0) continue;
      // Make matching (case-insensitive)
      var matchedMake = false;
      for (var j = 0; j < KNOWN_MAKES.length; j++) {
        if (KNOWN_MAKES[j].toLowerCase() === tLower) {
          var canonical = MAKE_CANONICAL[KNOWN_MAKES[j]] || KNOWN_MAKES[j];
          if (result.makes.indexOf(canonical) === -1) result.makes.push(canonical);
          matchedMake = true;
          break;
        }
      }
      if (matchedMake) continue;
      // Series matching (case-sensitive)
      if (KNOWN_SERIES.indexOf(t) >= 0) {
        if (result.series.indexOf(t) === -1) result.series.push(t);
        continue;
      }
      // Year range
      if (YEAR_RANGE_RE.test(t) || YEAR_SINGLE_RE.test(t)) {
        var yr = parseYearToken(t);
        if (yr) { yearRanges.push(yr); continue; }
      }
      // Otherwise model
      if (result.models.indexOf(t) === -1) result.models.push(t);
    }
    if (yearRanges.length > 0) {
      result.yearStart = Math.min.apply(null, yearRanges.map(function (y) { return y[0]; }));
      result.yearEnd = Math.max.apply(null, yearRanges.map(function (y) { return y[1]; }));
    }
    return result;
  }

  // Shopify product types that are "always universal" — packing kits, gear,
  // t-shirts, accessories. Used to distinguish actual universal products from
  // products that were merely under-tagged.
  var UNIVERSAL_PRODUCT_TYPES = ['accessories', 'gear', 'parts', 'exhaust parts'];

  // ------------------------------------------------------------------------
  // Fitment check — does this product fit the active vehicle?
  // Returns: 'fits' | 'no_fit' | 'wrong_year' | 'universal' | 'untagged' | 'unknown'
  //
  //   fits        – make/model/year all match
  //   wrong_year  – make+model match but year is out of range (amber badge)
  //   no_fit      – make or model mismatch (red badge)
  //   universal   – product has no fitment tags AND is a universal product type
  //                 (Accessories, Gear, etc). Safe to show as "Universal".
  //   untagged    – product has no fitment tags but is NOT a universal type.
  //                 Likely a data hygiene gap. Show no badge to avoid mis-promising.
  //   unknown     – no active vehicle, or vehicle missing required fields
  // ------------------------------------------------------------------------
  function checkFitment(productFitment, vehicle, productType) {
    if (!vehicle) return 'unknown';
    var noFitData = productFitment.makes.length === 0 &&
                    productFitment.models.length === 0 &&
                    !productFitment.yearStart;
    if (noFitData) {
      var ptl = (productType || '').toLowerCase();
      return UNIVERSAL_PRODUCT_TYPES.indexOf(ptl) >= 0 ? 'universal' : 'untagged';
    }
    // Defensive: vehicle is normally populated by Garage.add() but could be
    // hand-edited via DevTools/localStorage. Treat missing make as "unknown".
    var vmake  = (vehicle.make  || '').toLowerCase();
    var vmodel = (vehicle.model || '').toLowerCase();
    if (!vmake) return 'unknown';
    // Compute make + model match independently from year
    var makeMatches = productFitment.makes.length === 0 ||
      productFitment.makes.some(function (m) { return m.toLowerCase() === vmake; });
    var modelMatches = productFitment.models.length === 0 || !vmodel ||
      productFitment.models.some(function (mdl) { return mdl.toLowerCase() === vmodel; });

    // Wrong make or wrong model -> hard no_fit regardless of year
    if (!makeMatches || !modelMatches) return 'no_fit';

    // Make + model match — now check year
    if (productFitment.yearStart && productFitment.yearEnd) {
      var y = parseInt(vehicle.year, 10);
      if (isNaN(y)) return 'fits'; // year unknown — be permissive
      if (y < productFitment.yearStart || y > productFitment.yearEnd) return 'wrong_year';
    }
    return 'fits';
  }

  // Format a year range into the compact form the catalog uses ('09-13'),
  // falling back to four-digit when the range straddles centuries.
  function formatYearRange(start, end) {
    if (start >= 2000 && start < 2100 && end >= 2000 && end < 2100) {
      var s = ('0' + (start - 2000)).slice(-2);
      var e = ('0' + (end - 2000)).slice(-2);
      return s + '-' + e;
    }
    return start + '-' + end;
  }

  // ------------------------------------------------------------------------
  // SVG icons (inline, self-contained)
  // ------------------------------------------------------------------------
  var ICONS = {
    garage: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-6 9 6v11H3z"/><path d="M7 21v-9h10v9"/><path d="M7 16h10"/></svg>',
    check:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    x:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    info:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
    alert:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
    trash:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>'
  };

  // ------------------------------------------------------------------------
  // Vehicle name formatting
  // ------------------------------------------------------------------------
  function formatVehicleName(v) {
    if (!v) return '';
    return [v.year, v.make, v.model].filter(Boolean).join(' ');
  }

  // ------------------------------------------------------------------------
  // Garage state machine
  // ------------------------------------------------------------------------
  var Garage = {
    _state: { vehicles: [], activeId: null },
    _vocab: null,
    _listeners: [],

    init: function () {
      this._state = loadState();
      this._loadVocab();
    },

    _loadVocab: function () {
      var self = this;
      if (!VOCAB_URL) {
        console.warn('[BGE Garage] Vocabulary URL not configured');
        return;
      }
      fetch(VOCAB_URL, { credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('vocab HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          // Validate vocab shape — protects against Shopify returning a 200
          // HTML page (e.g., asset 404 redirected to storefront) that parses
          // as JSON but lacks the expected structure.
          if (!data || !Array.isArray(data.years) || !Array.isArray(data.makes) ||
              !data.models_by_make || typeof data.models_by_make !== 'object') {
            console.warn('[BGE Garage] Vocabulary file has unexpected shape');
            return;
          }
          self._vocab = data;
          self._emit('vocab_loaded');
        })
        .catch(function (err) {
          console.warn('[BGE Garage] Vocabulary load failed:', err);
        });
    },

    list: function () { return this._state.vehicles.slice(); },

    active: function () {
      if (!this._state.activeId) return null;
      for (var i = 0; i < this._state.vehicles.length; i++) {
        if (this._state.vehicles[i].id === this._state.activeId) return this._state.vehicles[i];
      }
      return null;
    },

    add: function (year, make, model) {
      if (this._state.vehicles.length >= MAX_VEHICLES) return null;
      var id = 'v_' + Date.now() + '_' + Math.floor(Math.random() * 1000);
      var v = { id: id, year: year, make: make, model: model || '' };
      // Don't add duplicates — use strict equality + coerce year to number
      var yearNum = parseInt(year, 10);
      var dupe = this._state.vehicles.find(function (ex) {
        return parseInt(ex.year, 10) === yearNum && ex.make === make && (ex.model || '') === (model || '');
      });
      if (dupe) {
        this.setActive(dupe.id);
        return dupe;
      }
      this._state.vehicles.push(v);
      this._state.activeId = id;
      saveState(this._state);
      this._emit('change');
      return v;
    },

    remove: function (id) {
      this._state.vehicles = this._state.vehicles.filter(function (v) { return v.id !== id; });
      if (this._state.activeId === id) {
        this._state.activeId = this._state.vehicles[0] ? this._state.vehicles[0].id : null;
      }
      saveState(this._state);
      this._emit('change');
    },

    setActive: function (id) {
      var found = this._state.vehicles.find(function (v) { return v.id === id; });
      if (!found) return;
      this._state.activeId = id;
      saveState(this._state);
      this._emit('change');
    },

    clearActive: function () {
      this._state.activeId = null;
      saveState(this._state);
      this._emit('change');
    },

    fits: function (tagsStr) {
      var parsed = parseTags(tagsStr);
      return checkFitment(parsed, this.active());
    },

    onChange: function (cb) { this._listeners.push(cb); },

    _emit: function (event) {
      for (var i = 0; i < this._listeners.length; i++) {
        try { this._listeners[i](event); } catch (e) { /* swallow */ }
      }
    },

    get vocab() { return this._vocab; }
  };

  // ------------------------------------------------------------------------
  // UI Renderers
  // ------------------------------------------------------------------------

  // ----- Garage bar -----
  function renderBar() {
    var bar = document.querySelector('[data-bge-garage-bar]');
    if (!bar) return;
    var active = Garage.active();
    if (active) {
      bar.innerHTML =
        '<div class="bge-garage-bar__inner">' +
          '<span class="bge-garage-bar__icon">' + ICONS.garage + '</span>' +
          '<span class="bge-garage-bar__label">Fitment</span>' +
          '<span class="bge-garage-bar__vehicle">' + escapeHtml(formatVehicleName(active)) + '</span>' +
          '<button type="button" class="bge-garage-bar__cta" data-bge-action="open-drawer">View My Garage</button>' +
          '<button type="button" class="bge-garage-bar__cta bge-garage-bar__cta--ghost" data-bge-action="open-drawer">Change</button>' +
          '<button type="button" class="bge-garage-bar__cta bge-garage-bar__cta--text" data-bge-action="clear-active" aria-label="Clear active vehicle">Clear</button>' +
        '</div>';
    } else {
      bar.innerHTML =
        '<div class="bge-garage-bar__inner">' +
          '<span class="bge-garage-bar__icon">' + ICONS.garage + '</span>' +
          '<span class="bge-garage-bar__empty">Add your ATV to see parts that fit</span>' +
          '<button type="button" class="bge-garage-bar__cta" data-bge-action="open-drawer">+ Vehicle</button>' +
        '</div>';
    }
  }

  // ----- Garage drawer body -----
  function renderDrawer() {
    var body = document.querySelector('[data-bge-drawer-body]');
    if (!body) return;
    var vehicles = Garage.list();
    var active = Garage.active();
    var html = '';

    if (active) {
      html += '<div class="bge-garage-drawer__section">';
      html +=   '<div class="bge-garage-drawer__section-title">Active Vehicle</div>';
      html +=   '<div class="bge-garage-vehicle-card bge-garage-vehicle-card--active">';
      html +=     '<div class="bge-garage-vehicle-card__label">Showing parts that fit</div>';
      html +=     '<div class="bge-garage-vehicle-card__name">' + escapeHtml(formatVehicleName(active)) + '</div>';
      html +=     '<div class="bge-garage-vehicle-card__actions">';
      html +=       '<button type="button" class="bge-garage-vehicle-card__action" data-bge-action="browse-fit">Browse parts that fit</button>';
      html +=       '<button type="button" class="bge-garage-vehicle-card__action bge-garage-vehicle-card__action--danger" data-bge-action="remove-vehicle" data-id="' + active.id + '">Remove</button>';
      html +=     '</div>';
      html +=   '</div>';
      html += '</div>';
    }

    // Saved vehicles list (excluding active)
    var others = vehicles.filter(function (v) { return !active || v.id !== active.id; });
    if (others.length > 0) {
      html += '<div class="bge-garage-drawer__section">';
      html +=   '<div class="bge-garage-drawer__section-title">Saved Vehicles</div>';
      html +=   '<div class="bge-garage-saved-list">';
      others.forEach(function (v) {
        html += '<div class="bge-garage-saved-row">';
        html +=   '<div class="bge-garage-saved-row__name">' + escapeHtml(formatVehicleName(v)) + '</div>';
        html +=   '<div class="bge-garage-saved-row__actions">';
        html +=     '<button type="button" class="bge-garage-saved-row__btn" data-bge-action="set-active" data-id="' + v.id + '">Set Active</button>';
        html +=     '<button type="button" class="bge-garage-saved-row__btn bge-garage-saved-row__btn--icon" data-bge-action="remove-vehicle" data-id="' + v.id + '" aria-label="Remove">' + ICONS.trash + '</button>';
        html +=   '</div>';
        html += '</div>';
      });
      html +=   '</div>';
      html += '</div>';
    }

    // Add vehicle form
    var canAdd = vehicles.length < MAX_VEHICLES;
    html += '<div class="bge-garage-drawer__section">';
    html +=   '<div class="bge-garage-drawer__section-title">' + (vehicles.length === 0 ? 'Add Your Vehicle' : 'Add Another Vehicle') + '</div>';
    if (canAdd) {
      html += '<form class="bge-ymm-form" data-bge-ymm-form>';
      html +=   '<div class="bge-ymm-field"><label class="bge-ymm-field__label" for="bge-ymm-year">Year</label><select class="bge-ymm-field__select" id="bge-ymm-year" data-bge-ymm-year></select></div>';
      html +=   '<div class="bge-ymm-field"><label class="bge-ymm-field__label" for="bge-ymm-make">Make</label><select class="bge-ymm-field__select" id="bge-ymm-make" data-bge-ymm-make disabled></select></div>';
      html +=   '<div class="bge-ymm-field"><label class="bge-ymm-field__label" for="bge-ymm-model">Model</label><select class="bge-ymm-field__select" id="bge-ymm-model" data-bge-ymm-model disabled></select></div>';
      html +=   '<button type="submit" class="bge-ymm-submit" data-bge-ymm-submit disabled>Find My Parts</button>';
      html +=   '<p class="bge-ymm-helper">Saved to this browser. Add up to ' + MAX_VEHICLES + ' vehicles to your garage.</p>';
      html += '</form>';
    } else {
      html += '<div class="bge-empty-state">Garage is full (' + MAX_VEHICLES + ' vehicles). Remove one to add another.</div>';
    }
    html += '</div>';

    body.innerHTML = html;
    if (canAdd) initYmmForm();
  }

  var YMM_INIT_MAX_RETRIES = 25; // 25 * 200ms = 5s cap before giving up
  function initYmmForm(retryCount) {
    retryCount = retryCount || 0;
    var vocab = Garage.vocab;
    if (!vocab) {
      if (retryCount < YMM_INIT_MAX_RETRIES) {
        setTimeout(function () { initYmmForm(retryCount + 1); }, 200);
      } else {
        // Give up after 5s. Surface a hint to the user inside the drawer body.
        var body = document.querySelector('[data-bge-drawer-body]');
        if (body) {
          var hint = document.createElement('div');
          hint.className = 'bge-empty-state';
          hint.textContent = 'Vehicle list unavailable. Please refresh and try again.';
          body.appendChild(hint);
        }
      }
      return;
    }
    var yearSel  = document.querySelector('[data-bge-ymm-year]');
    var makeSel  = document.querySelector('[data-bge-ymm-make]');
    var modelSel = document.querySelector('[data-bge-ymm-model]');
    var submit   = document.querySelector('[data-bge-ymm-submit]');
    if (!yearSel || !makeSel || !modelSel || !submit) return;

    // Normalize each vocab entry to {name, year_start, year_end}. Tolerates the
    // older string-only shape just in case the JSON gets swapped during an
    // update.
    function modelEntries(make) {
      var raw = (vocab.models_by_make && vocab.models_by_make[make]) || [];
      return raw.map(function (m) {
        return typeof m === 'string'
          ? { name: m, year_start: 1985, year_end: 2030 }
          : m;
      });
    }
    function modelMatchesYear(m, y) {
      return !y || (y >= m.year_start && y <= m.year_end);
    }
    function makeMatchesYear(make, y) {
      if (!y) return true;
      return modelEntries(make).some(function (m) { return modelMatchesYear(m, y); });
    }

    yearSel.innerHTML = '<option value="">Year</option>' + vocab.years.map(function (y) {
      return '<option value="' + y + '">' + y + '</option>';
    }).join('');

    function refresh() {
      var year = yearSel.value;
      var make = makeSel.value;
      var model = modelSel.value;
      makeSel.disabled = !year;
      modelSel.disabled = !year || !make;
      submit.disabled = !(year && make);
      submit.textContent = (year && make) ? 'Add ' + [year, make, model].filter(Boolean).join(' ') : 'Find My Parts';
    }

    yearSel.addEventListener('change', function () {
      var y = parseInt(yearSel.value, 10);
      var prevMake  = makeSel.value;
      var prevModel = modelSel.value;
      // Cascade: only show makes that have at least one model in this year.
      var availableMakes = vocab.makes.filter(function (m) { return makeMatchesYear(m, y); });
      makeSel.innerHTML = '<option value="">Make</option>' + availableMakes.map(function (m) {
        var sel = m === prevMake ? ' selected' : '';
        return '<option value="' + escapeAttr(m) + '"' + sel + '>' + escapeHtml(m) + '</option>';
      }).join('');
      // Preserve model if previous make+model still compatible with new year
      if (prevMake && availableMakes.indexOf(prevMake) >= 0) {
        var availableModels = modelEntries(prevMake).filter(function (m) { return modelMatchesYear(m, y); });
        modelSel.innerHTML = '<option value="">Model (optional)</option>' + availableModels.map(function (m) {
          var sel = m.name === prevModel ? ' selected' : '';
          return '<option value="' + escapeAttr(m.name) + '"' + sel + '>' + escapeHtml(m.name) + '</option>';
        }).join('');
      } else {
        modelSel.innerHTML = '<option value="">Model (optional)</option>';
      }
      refresh();
    });

    makeSel.addEventListener('change', function () {
      var y = parseInt(yearSel.value, 10);
      var make = makeSel.value;
      var prevModel = modelSel.value;
      // Cascade: only show models compatible with the chosen year.
      var availableModels = modelEntries(make).filter(function (m) { return modelMatchesYear(m, y); });
      modelSel.innerHTML = '<option value="">Model (optional)</option>' + availableModels.map(function (m) {
        var sel = m.name === prevModel ? ' selected' : '';
        return '<option value="' + escapeAttr(m.name) + '"' + sel + '>' + escapeHtml(m.name) + '</option>';
      }).join('');
      refresh();
    });

    modelSel.addEventListener('change', refresh);

    var form = document.querySelector('[data-bge-ymm-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!yearSel.value || !makeSel.value) return;
        var v = Garage.add(parseInt(yearSel.value, 10), makeSel.value, modelSel.value);
        closeDrawer();
        // Auto-navigate to the strict-fit collection so the user immediately
        // sees parts for their vehicle (instead of staying on the current page).
        if (v) {
          window.location.href = buildBrowseUrl(v, { strict: true });
        }
      });
    }
  }

  // ----- Drawer open/close -----
  // Track the element that triggered the drawer so we can restore focus on
  // close (WCAG 2.4.3 keeps the keyboard user oriented).
  var _drawerOpenerEl = null;

  function getDrawerFocusables() {
    var drawer = document.querySelector('[data-bge-drawer]');
    if (!drawer) return [];
    var sel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(drawer.querySelectorAll(sel))
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function onDrawerKeydown(e) {
    if (e.key !== 'Tab') return;
    var focusables = getDrawerFocusables();
    if (focusables.length === 0) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-bge-drawer]');
    var overlay = document.querySelector('[data-bge-overlay]');
    if (!drawer || !overlay) return;
    _drawerOpenerEl = document.activeElement;
    renderDrawer();
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('bge-garage-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.addEventListener('keydown', onDrawerKeydown);
    // Move focus into the drawer so screen-readers + keyboard users land here.
    // setTimeout gives the transition a beat to complete first.
    setTimeout(function () {
      var focusables = getDrawerFocusables();
      if (focusables.length > 0) focusables[0].focus();
    }, 50);
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-bge-drawer]');
    var overlay = document.querySelector('[data-bge-overlay]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.removeEventListener('keydown', onDrawerKeydown);
    }
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('bge-garage-open');
    // Restore focus to whatever opened the drawer.
    if (_drawerOpenerEl && typeof _drawerOpenerEl.focus === 'function') {
      try { _drawerOpenerEl.focus(); } catch (e) { /* element may be gone */ }
    }
    _drawerOpenerEl = null;
  }

  // ----- Fitment badges on product cards -----
  function renderFitmentBadges() {
    var active = Garage.active();
    var cards = document.querySelectorAll('[data-bge-tags]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var tags = card.getAttribute('data-bge-tags') || '';
      var productType = card.getAttribute('data-bge-type') || '';
      var parsed = parseTags(tags);
      var state = checkFitment(parsed, active, productType);

      // Find or create badge slot
      var slot = card.querySelector('.bge-fitment-badge-slot');
      if (!slot) {
        var imageWrap = card.querySelector('.product-image') || card;
        slot = document.createElement('div');
        slot.className = 'bge-fitment-badge-slot';
        imageWrap.appendChild(slot);
      }

      // Untagged: under-tagged product — don't promise universal fit. No badge.
      // Unknown: no active vehicle.
      if (state === 'unknown' || state === 'untagged') {
        slot.innerHTML = '';
        continue;
      }
      if (state === 'universal' && !active) {
        // Don't clutter cards with universal badges when no garage
        slot.innerHTML = '';
        continue;
      }
      slot.innerHTML = badgeHtml(state, active, parsed);
    }
  }

  function badgeHtml(state, vehicle, productFitment) {
    var label, cls, icon;
    switch (state) {
      case 'fits':
        label = vehicle ? 'Fits Your ' + (vehicle.year || '') : 'Fits';
        cls = 'bge-fitment-badge--fits';
        icon = ICONS.check;
        break;
      case 'wrong_year':
        if (productFitment && productFitment.yearStart && productFitment.yearEnd) {
          label = 'Fits ' + formatYearRange(productFitment.yearStart, productFitment.yearEnd);
        } else {
          label = 'Different Year';
        }
        cls = 'bge-fitment-badge--wrong-year';
        icon = ICONS.alert;
        break;
      case 'no_fit':
        label = 'Does Not Fit';
        cls = 'bge-fitment-badge--no-fit';
        icon = ICONS.x;
        break;
      case 'universal':
        label = 'Universal';
        cls = 'bge-fitment-badge--universal';
        icon = '';
        break;
      default:
        return '';
    }
    return '<span class="bge-fitment-badge ' + cls + '">' + (icon || '') + ' ' + escapeHtml(label) + '</span>';
  }

  // ----- PDP fitment panel -----
  function renderPdpFitmentPanel() {
    var panel = document.querySelector('[data-bge-pdp-fitment]');
    if (!panel) return;
    var tags = panel.getAttribute('data-bge-tags') || '';
    var productType = panel.getAttribute('data-bge-type') || '';
    var parsed = parseTags(tags);
    var active = Garage.active();
    var state = checkFitment(parsed, active, productType);

    var classes = ['bge-pdp-fitment'];
    var label, title, action = '', icon;
    switch (state) {
      case 'fits':
        classes.push('bge-pdp-fitment--fits');
        label = 'Fitment Confirmed';
        title = 'Fits your ' + formatVehicleName(active);
        icon = ICONS.check;
        break;
      case 'wrong_year':
        classes.push('bge-pdp-fitment--wrong-year');
        label = 'Year Does Not Match';
        if (parsed.yearStart && parsed.yearEnd) {
          title = 'This part fits ' + formatYearRange(parsed.yearStart, parsed.yearEnd) +
                  ' ' + active.make + (active.model ? ' ' + active.model : '') +
                  '. Your ' + active.year + ' is outside this range.';
        } else {
          title = 'Year does not match your ' + formatVehicleName(active);
        }
        icon = ICONS.alert;
        action =
          '<a class="bge-pdp-fitment__action bge-pdp-fitment__action--primary" href="' + escapeAttr(buildBrowseUrl(active, { strict: true })) + '">Show parts that fit my ' + escapeHtml(active.make + (active.model ? ' ' + active.model : '')) + '</a>' +
          '<button type="button" class="bge-pdp-fitment__action bge-pdp-fitment__action--ghost" data-bge-action="open-drawer">Change Vehicle</button>';
        break;
      case 'no_fit':
        classes.push('bge-pdp-fitment--no-fit');
        label = 'Fitment Issue';
        title = 'Does not fit your ' + formatVehicleName(active);
        icon = ICONS.x;
        action =
          '<a class="bge-pdp-fitment__action bge-pdp-fitment__action--primary" href="' + escapeAttr(buildBrowseUrl(active, { strict: true })) + '">Show parts that fit my ' + escapeHtml(active.make + (active.model ? ' ' + active.model : '')) + '</a>' +
          '<button type="button" class="bge-pdp-fitment__action bge-pdp-fitment__action--ghost" data-bge-action="open-drawer">Change Vehicle</button>';
        break;
      case 'universal':
        classes.push('bge-pdp-fitment--universal');
        label = 'Universal Fitment';
        title = 'Fits all vehicles';
        icon = ICONS.info;
        break;
      case 'untagged':
        classes.push('bge-pdp-fitment--unknown');
        label = 'Fitment Not Specified';
        title = 'Contact us to confirm this part fits your ' + formatVehicleName(active);
        icon = ICONS.alert;
        action = '<a class="bge-pdp-fitment__action bge-pdp-fitment__action--primary" href="mailto:sales@biggunexhaust.com?subject=Fitment%20question%20-%20' + encodeURIComponent(document.title) + '">Ask About Fitment</a>';
        break;
      default:
        classes.push('bge-pdp-fitment--unknown');
        label = 'Will this fit your ATV?';
        title = 'Add your vehicle to confirm fitment';
        icon = ICONS.alert;
        action = '<button type="button" class="bge-pdp-fitment__action bge-pdp-fitment__action--primary" data-bge-action="open-drawer">+ Add Vehicle</button>';
        break;
    }
    panel.className = classes.join(' ');
    panel.innerHTML =
      '<div class="bge-pdp-fitment__icon">' + icon + '</div>' +
      '<div class="bge-pdp-fitment__body">' +
        '<div class="bge-pdp-fitment__label">' + label + '</div>' +
        '<div class="bge-pdp-fitment__title">' + escapeHtml(title) + '</div>' +
        action +
      '</div>';
  }

  // ------------------------------------------------------------------------
  // Strict-fit filter
  // When the URL contains ?bge_strict=1 (set by "View parts that fit my vehicle"),
  // hide product cards that don't fit the active vehicle. If everything is hidden,
  // show a banner that explains why and offers ways to broaden the search.
  // ------------------------------------------------------------------------
  function applyStrictFilter() {
    var url = new URL(window.location.href);
    var strict = url.searchParams.get('bge_strict') === '1';
    var existing = document.querySelector('.bge-strict-empty');

    // If strict mode is OFF, make sure nothing is hidden by us and clear any banner.
    var restoreHidden = function () {
      document.querySelectorAll('[data-bge-strict-hidden]').forEach(function (el) {
        el.style.display = '';
        el.removeAttribute('data-bge-strict-hidden');
      });
    };
    if (!strict) {
      restoreHidden();
      if (existing) existing.remove();
      return;
    }

    var active = Garage.active();
    if (!active) {
      // Active vehicle was cleared while still on a strict-filtered URL —
      // restore any cards we previously hid so the user isn't stranded.
      restoreHidden();
      if (existing) existing.remove();
      return;
    }

    var cards = document.querySelectorAll('[data-bge-tags]');
    var visibleCount = 0;
    var hiddenWrongYearRanges = [];
    var hiddenNoFit = 0;

    cards.forEach(function (card) {
      var tags = card.getAttribute('data-bge-tags') || '';
      var productType = card.getAttribute('data-bge-type') || '';
      var parsed = parseTags(tags);
      var state = checkFitment(parsed, active, productType);
      // The Halo theme wraps cards in .halo-item — hide the wrapper so the
      // grid reflows correctly.
      var wrapper = card.closest('.halo-item') || card.parentElement || card;

      if (state === 'wrong_year') {
        wrapper.style.display = 'none';
        wrapper.setAttribute('data-bge-strict-hidden', 'wrong_year');
        if (parsed.yearStart && parsed.yearEnd) {
          hiddenWrongYearRanges.push([parsed.yearStart, parsed.yearEnd]);
        }
      } else if (state === 'no_fit') {
        wrapper.style.display = 'none';
        wrapper.setAttribute('data-bge-strict-hidden', 'no_fit');
        hiddenNoFit++;
      } else {
        if (wrapper.getAttribute('data-bge-strict-hidden')) {
          wrapper.style.display = '';
          wrapper.removeAttribute('data-bge-strict-hidden');
        }
        visibleCount++;
      }
    });

    if (visibleCount === 0 && (hiddenWrongYearRanges.length > 0 || hiddenNoFit > 0)) {
      var availableRange = '';
      if (hiddenWrongYearRanges.length > 0) {
        var minY = Math.min.apply(null, hiddenWrongYearRanges.map(function (r) { return r[0]; }));
        var maxY = Math.max.apply(null, hiddenWrongYearRanges.map(function (r) { return r[1]; }));
        availableRange = formatYearRange(minY, maxY);
      }
      showStrictEmptyState(active, availableRange, hiddenWrongYearRanges.length, hiddenNoFit);
    } else if (existing) {
      existing.remove();
    }
  }

  function showStrictEmptyState(vehicle, availableRange, wrongYearCount, noFitCount) {
    var container =
      document.querySelector('#collection-page') ||
      document.querySelector('#Collection') ||
      document.querySelector('.halo-column-product') ||
      document.querySelector('.page-collections') ||
      document.querySelector('main');
    if (!container) return;

    var existing = document.querySelector('.bge-strict-empty');
    if (existing) existing.remove();

    var vehicleName = formatVehicleName(vehicle);
    var modelLabel = vehicle.make + (vehicle.model ? ' ' + vehicle.model : '');

    var explanation;
    if (wrongYearCount > 0 && availableRange) {
      explanation = 'We make parts for the ' + escapeHtml(modelLabel) +
        ' in ' + escapeHtml(availableRange) + '. Your ' + escapeHtml(String(vehicle.year)) +
        ' is outside the range we support.';
    } else if (wrongYearCount > 0) {
      explanation = 'We make parts for the ' + escapeHtml(modelLabel) +
        ' but not for your ' + escapeHtml(String(vehicle.year)) + ' model year.';
    } else {
      explanation = 'We do not currently have parts cataloged for your ' + escapeHtml(vehicleName) + '.';
    }

    var anyYearUrl  = buildBrowseUrl(vehicle); // make+model, no strict
    var makeOnlyUrl = buildBrowseUrl(vehicle, { makeOnly: true });

    var notice = document.createElement('div');
    notice.className = 'bge-strict-empty';
    notice.innerHTML =
      '<div class="bge-strict-empty__inner">' +
        '<div class="bge-strict-empty__icon">' + ICONS.alert + '</div>' +
        '<div class="bge-strict-empty__content">' +
          '<div class="bge-strict-empty__label">No exact-fit parts</div>' +
          '<h2 class="bge-strict-empty__title">No parts fit your ' + escapeHtml(vehicleName) + ' in this view.</h2>' +
          '<p class="bge-strict-empty__body">' + explanation + '</p>' +
          '<div class="bge-strict-empty__actions">' +
            '<a class="bge-pdp-fitment__action bge-pdp-fitment__action--primary" href="' + escapeAttr(anyYearUrl) + '">Show all ' + escapeHtml(modelLabel) + ' parts (any year)</a>' +
            '<a class="bge-pdp-fitment__action bge-pdp-fitment__action--ghost" href="' + escapeAttr(makeOnlyUrl) + '">Show all ' + escapeHtml(vehicle.make) + ' parts</a>' +
            '<button type="button" class="bge-pdp-fitment__action bge-pdp-fitment__action--ghost" data-bge-action="open-drawer">Change Vehicle</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    container.insertBefore(notice, container.firstChild);
  }

  // ------------------------------------------------------------------------
  // Event delegation
  // ------------------------------------------------------------------------
  function onClick(e) {
    var t = e.target;
    while (t && t !== document.body) {
      var action = t.getAttribute && t.getAttribute('data-bge-action');
      if (action) {
        handleAction(action, t, e);
        return;
      }
      t = t.parentNode;
    }
  }

  function handleAction(action, el, e) {
    if (action === 'open-drawer')      { e.preventDefault(); openDrawer(); }
    else if (action === 'close-drawer'){ e.preventDefault(); closeDrawer(); }
    else if (action === 'clear-active'){ e.preventDefault(); Garage.clearActive(); }
    else if (action === 'set-active')  { e.preventDefault(); Garage.setActive(el.getAttribute('data-id')); renderDrawer(); }
    else if (action === 'remove-vehicle'){ e.preventDefault(); Garage.remove(el.getAttribute('data-id')); renderDrawer(); }
    else if (action === 'browse-fit')  { e.preventDefault(); closeDrawer(); window.location.href = buildBrowseUrl(Garage.active(), { strict: true }); }
  }

  function onKey(e) {
    if (e.key === 'Escape') closeDrawer();
  }

  // ------------------------------------------------------------------------
  // Helpers
  // ------------------------------------------------------------------------

  // Shopify tag-handle: lowercase, replace non-alphanum runs with hyphens, trim.
  // Matches Shopify's internal handleize() so /collections/all/<handle> works.
  function handleizeTag(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Build a Shopify path-based tag filter URL for the active vehicle.
  // opts.strict=true  → append ?bge_strict=1 so client-side filter hides
  //                     wrong-year/no-fit cards (used by "Show parts that fit").
  // opts.makeOnly=true→ omit model from path (looser, make-only filter).
  // Falls back to /collections/all when no vehicle/make.
  // Maps dropdown canonical → catalog tag form when they differ
  // (catalog tag is "Harley" but dropdown ships "Harley-Davidson", etc).
  function buildBrowseUrl(vehicle, opts) {
    opts = opts || {};
    if (!vehicle || !vehicle.make) return '/collections/all';
    var make = vehicle.make;
    var TAG_OVERRIDES = { 'Harley-Davidson': 'Harley', 'Can-Am': 'Can Am' };
    if (TAG_OVERRIDES[make]) make = TAG_OVERRIDES[make];
    var handles = [handleizeTag(make)];
    if (vehicle.model && !opts.makeOnly) handles.push(handleizeTag(vehicle.model));
    var url = '/collections/all/' + handles.join('+');
    if (opts.strict) url += '?bge_strict=1';
    return url;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  // ------------------------------------------------------------------------
  // Boot
  // ------------------------------------------------------------------------
  function boot() {
    Garage.init();
    document.addEventListener('click', onClick, false);
    document.addEventListener('keydown', onKey, false);

    // Cross-tab sync — if the user updates their garage in another tab, refresh
    // this tab's state. Storage events fire in OTHER tabs, not the originating
    // one, so this won't cause echo loops.
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) {
        Garage._state = loadState();
        Garage._emit('change');
      }
    });

    Garage.onChange(function () {
      renderBar();
      renderFitmentBadges();
      renderPdpFitmentPanel();
      applyStrictFilter();
    });

    // Initial render after vocab loads (so badges have data)
    var initial = function () {
      renderBar();
      renderFitmentBadges();
      renderPdpFitmentPanel();
      applyStrictFilter();
    };
    initial();
    // Also re-render after vocab loads (in case bar/badge rendering depended on it)
    setTimeout(initial, 400);

    // Re-render badges if the product grid updates (e.g., infinite scroll / pagination AJAX)
    var observer = new MutationObserver(function (mutations) {
      var shouldRerender = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          for (var j = 0; j < mutations[i].addedNodes.length; j++) {
            var n = mutations[i].addedNodes[j];
            if (n.nodeType === 1 && (n.matches && n.matches('[data-bge-tags]') ||
                n.querySelector && n.querySelector('[data-bge-tags]'))) {
              shouldRerender = true;
              break;
            }
          }
        }
        if (shouldRerender) break;
      }
      if (shouldRerender) { renderFitmentBadges(); applyStrictFilter(); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Expose for debugging
  window.BGE = window.BGE || {};
  window.BGE.Garage = Garage;
  window.BGE.openGarage = openDrawer;
  window.BGE.closeGarage = closeDrawer;
  window.BGE.parseTags = parseTags;
  window.BGE.checkFitment = checkFitment;
})();
